module.exports = __webpack_public_path__ + "img/penny-pinch-name-logo.c39840eb.svg";